var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [_vm.$.header, _vm.backIcon ? "" : _vm.$.border_bottom],
      style: Object.assign({}, _vm.styles),
    },
    [
      _c("div", { class: _vm.$.top }, [
        _c("div", { class: _vm.$.top__left }, [
          _c(
            "div",
            { class: _vm.$.button },
            [
              _vm.backIcon
                ? _c("icon-button", {
                    attrs: { icon: { name: "arrow-left" }, size: "small" },
                    on: {
                      onClick: function ($event) {
                        return _vm.$emit("backClick")
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { class: _vm.$.title }, [
            _vm._v("\n        " + _vm._s(_vm.title) + "\n      "),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { class: _vm.$.top__right },
          [
            _vm.helpIcon
              ? _c("icon-button", {
                  style: { color: _vm.helpIconColor },
                  attrs: { icon: { name: "help" }, size: "small" },
                  on: {
                    onClick: function ($event) {
                      return _vm.helpClick($event)
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("icon-button", {
              attrs: { icon: { name: "close-1" }, size: "small" },
              on: {
                onClick: function ($event) {
                  return _vm.$emit("closeClick")
                },
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.componentName === "filterMain" && _vm.accessToSavedFilters
        ? _c(
            "div",
            { class: _vm.$.filters_dropdown },
            [
              _c("dropdown-select", {
                attrs: {
                  "drop-list": _vm.options,
                  placeholder: _vm.locales("filter_select_saved_filters"),
                  multiselect: false,
                  "show-selected-first": false,
                  "show-reset-btn": true,
                  "highlight-active-state": false,
                  "item-template": "text",
                  "track-by-text": "name",
                  outline: "none",
                  "custom-class": "filter_cmp_saved_filters_dropdown",
                  "use-select-all": false,
                  "popup-max-height": 200,
                  "arrow-icon": {
                    name: "arrow-down",
                    type: "regular",
                    size: 24,
                  },
                  selected: _vm.selectedFilter,
                },
                on: {
                  selected: _vm.selectFilter,
                  onResetClick: function ($event) {
                    return _vm.$emit("onResetClickFromHeader")
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }